import { withParams } from "vuelidate";
import { between } from "vuelidate/lib/validators";
export default (function (prop, min, max) { return withParams({ type: 'betweenIf', prop: prop, min: min, max: max }, function (value, parentVM) {
    var bProp = typeof prop === "function" ? prop.call(this, parentVM) : parentVM[prop];
    return bProp ? between(min, max)(value) : true;
}); });



//////////////////
// WEBPACK FOOTER
// ./src/Validators/betweenIf.ts
// module id = 966
// module chunks = 24